import { css } from "lit"

export const languagesStyles = css`
  /* Languages */
  .languages {
    padding: 0 1.25rem;
    margin-bottom: 2rem;
  }

  .languages-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 0.75rem;
    /*
     * Use the standard footer (Avenir Book) weight rather than a synthetic
     * bold. The dead webfont CDN meant the bold rendered as a heavy faux-bold
     * of the fallback font, which read as inconsistent vs. the reference footer.
     */
    font-weight: 400;
  }

  .languages-label {
    color: #949494;
    margin-bottom: 1rem;
  }

  .languages-list {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    list-style: none;
    padding: 0;
    margin: 0;
    justify-content: center;
    max-width: 20rem;
  }

  .language-item {
    margin: 0;
  }

  .language-link {
    color: #333333;
  }

  .language-link:hover {
    color: #647a1c;
  }

  @media (min-width: 768px) {
    .languages-container {
      flex-direction: row;
      align-items: flex-start;
    }

    .languages-label {
      margin-bottom: 0;
      margin-right: 1.25rem;
      white-space: nowrap;
      text-align: right;
      flex: 1;
    }

    .languages-list {
      max-width: none;
      justify-content: flex-start;
    }
  }
`
